/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Logger } from 'src/app/core/logger';
import { WidgetsTimeRangeModel } from 'src/app/models/widgets/widgets-time-range.model';

@Component({
  selector: 'app-metadata-timerange',
  templateUrl: './metadata-timerange.component.html',
  styleUrls: ['./metadata-timerange.component.scss']
})
export class MetadataTimeRangeComponent implements OnInit {
  @Input() data: WidgetsTimeRangeModel = new WidgetsTimeRangeModel();

  form: FormGroup;
  nextValue: number = 0;
  errorMessage: string = "";

  constructor(
    private fb: FormBuilder,
    public cd: ChangeDetectorRef,
    private logger: Logger) {
    this.form = this.fb.group({
      heading: ['', Validators.maxLength(30)],
      description: ['', Validators.maxLength(100)]
    });
  }

  ngOnInit(): void {
    //this.setInitialValues();
  }

  getControls(): FormControl {
    return (this.form.get('options') as FormControl);
  }

  onClearAllOptions() {
    const add = this.form.get('options') as FormArray;
    while (add.length !== 0) {
      add.removeAt(0);
      this.nextValue--;
    }
  }
}
